<template>
  <figure class="story-quote">
    <blockquote class="story-quote__text">{{ quote }}</blockquote>
    <figcaption class="story-quote__caption">
      <StoryAuthorAvatar
        v-if="author.avatar"
        :avatar="author.avatar"
        :alt="author.name"
      />
      <div class="story-quote__meta">
        <span class="story-quote__name">{{ author.name }}</span>
        <span class="story-quote__role">{{ authorLine }}</span>
      </div>
    </figcaption>
  </figure>
</template>

<script>
import StoryAuthorAvatar from './StoryAuthorAvatar.vue';

export default {
  components: { StoryAuthorAvatar },
  props: {
    quote: {
      type: String,
      required: true,
    },
    author: {
      type: Object,
      required: true,
    },
  },
  computed: {
    authorLine() {
      const parts = [this.author.role, this.author.company].filter(Boolean);
      return parts.join(' at ');
    },
  },
};
</script>

<style scoped>
.story-quote {
  margin: 32px 0;
  padding: 12px 0 12px 20px;
  border-left: 1px solid #7693fc;
}

.story-quote__text {
  margin: 0 0 20px;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  font-style: italic;
  color: #17191d;
}

.story-quote__caption {
  display: flex;
  align-items: center;
  gap: 12px;
}

.story-quote__meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.story-quote__name {
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #17191d;
}

.story-quote__role {
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.5);
}

@media screen and (max-width: 768px) {
  .story-quote__text {
    font-size: 18px;
    line-height: 28px;
  }
}
</style>
